<!--
 * @Desc:
 * @Author: may.li
 * @Date: 2023-05-11 14:11:36
 * @LastEditors: wanglidong 王立冬
 * @LastEditTime: 2023-12-13 09:02:15
-->
<template>
    <div class="app-container">
        <!-- 查询条件 -->
        <div class="search-div common-section-bg">
            <div class="shaixuan-item">
                <el-date-picker v-model="publish_time"
                                type="daterange"
                                align="right"
                                start-placeholder="绑定时间起"
                                end-placeholder="绑定时间止"
                                :default-time="['00:00:00', '23:59:59']"
                                value-format="yyyy-MM-dd">
                </el-date-picker>
            </div>
            <div class="shaixuan-item">
                <el-button
                        type="primary"
                        style="background: #1890ff; border-color: #1890ff"
                        @click="searchClick()"
                        icon="el-icon-search"
                >
                    查询
                </el-button>
            </div>
        </div>


        <!-- 列表展示 -->
        <div class="common-section-bg common-section-body">
            <el-table
                    v-loading="listLoading"
                    size="mini"
                    :data="tableData"
                    style="width: 100%;"
                    row-key="id"

            >
                <el-table-column prop="commName" label="项目" minwidth="180">
                </el-table-column>
                <el-table-column prop="user_num" label="绑定人数" minwidth="180">
                </el-table-column>
                <el-table-column prop="fangwu_num" label="绑定户数" minwidth="180">
                </el-table-column>
                <el-table-column prop="resource_num" label="绑定资源数" minwidth="180">
                </el-table-column>
                <!--                <el-table-column-->
                <!--                        fixed="right"-->
                <!--                        align="center"-->
                <!--                        label="操作"-->
                <!--                        width="200"-->
                <!--                >-->
                <!--                    <template slot-scope="scope">-->
                <!--                        <div class="btns-wrap">-->
                <!--                            &lt;!&ndash; <el-button-->
                <!--                                type="danger"-->
                <!--                                style="-->
                <!--                                    background: #1067e0;-->
                <!--                                    border-color: #1067e0;-->
                <!--                                "-->
                <!--                                @click="clickItem(1, scope.row)"-->
                <!--                                >修改</el-button-->
                <!--                            > &ndash;&gt;-->
                <!--                        </div>-->
                <!--                    </template>-->
                <!--                </el-table-column>-->
            </el-table>
            <!-- 分页 -->
            <pagination
                    v-show="total"
                    :total="total"
                    :page.sync="queryParam.page"
                    :limit.sync="queryParam.size"
                    @pagination="getList"
            />
        </div>
        <el-drawer
                custom-class="custom-drawer"
                :visible.sync="showDrawer"
                :close-on-press-escape="false"
                :wrapper-closable="false"
                :show-close="false"
                size="660px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ isEdit ? "编辑" : "新增" }}</div>
                    <i
                            class="el-icon-circle-close close-btn pointer"
                            @click="closeDrawerFun"
                    />
                </div>
            </template>
            <div class="custom-content">
                <commonAdd
                        ref="commonAdd"
                        @onUpdateDrawer="onUpdateDrawer($event)"
                />
            </div>
        </el-drawer>
        <!-- 家庭成员 已绑定车辆 弹层 -->
        <el-drawer
                custom-class="custom-drawer"
                :visible.sync="showDrawer2"
                :close-on-press-escape="false"
                :wrapper-closable="false"
                :show-close="false"
                size="660px"
        >
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ content }}</div>
                    <i
                            class="el-icon-circle-close close-btn pointer"
                            @click="closeDrawerFun"
                    />
                </div>
            </template>
            <div class="custom-content">
                <familyMember v-if="content == '家庭成员'" ref="familyMember" @onUpdateDrawer="onUpdateDrawer($event)"></familyMember>
                <car ref="car" v-if="content == '已绑车辆'" @onUpdateDrawer="onUpdateDrawer($event)"></car>
            </div>
        </el-drawer>

    </div>
</template>

<script>
  import fetch from "@/api/tianzheng/Qu";
  import Pagination from "@/components/Pagination"; // Secondary package based on el-pagination
  export default {
    data() {
      return {
        publish_time:[],
        optionList: [],
        content:'',
        showDrawer2:false,
        queryParam: {
          resourceName:'',
          community_id: "",
          phone: "",
          page: 1,
          size: 10,
        },
        total: 0,
        listLoading: false,
        tableData: [],
        isEdit: 0, // 0新增 1编辑
        showDrawer: false,
        exportLoading:false
      };
    },
    components: {
      Pagination,
    },
    created() {

    },
    mounted() {
      this.getList();
      // this.getSelectCity()
    },
    methods: {
      exportData(){
        let that = this
        that.exportLoading = true;
        if (that.publish_time !== '' && that.publish_time !== null && that.publish_time !== undefined) {
          that.queryParam.begin_at = that.publish_time[0]
          that.queryParam.end_at = that.publish_time[1]
        } else {
          that.queryParam.begin_at = ''
          that.queryParam.end_at = ''
        }
        fetch.exportData(this.queryParam).then((res) => {
          if (res.code == 200) {
            console.log(res)
            if(res.result) {
              window.open(res.result)
            }
            that.exportLoading = false;
          } else {
            that.exportLoading = false;
            this.$message.error(res.message);
          }
        }).catch(err => {
          that.exportLoading = false;
          that.$message.error(err);
          console.log("报错信息", err);
        })

      },
      getSelectCity () {
        fetch.select({}).then(res => {
          if (res.code == 200) {
            this.optionList = res.result;
          }
        })
      },
      familyMember(row){
        let that = this
        this.content = '家庭成员'
        this.showDrawer2 = true
        // 给组件传值
        let obj = {
          id: row ? row.id : "",
        };
        this.$nextTick(function () {
          that.$refs.familyMember.initFun(obj);
        });
      },
      car(row){
        let that = this
        this.content = '已绑车辆'
        this.showDrawer2 = true
        // 给组件传值
        let obj = {
          id: row ? row.id : "",
        };
        this.$nextTick(function () {
          that.$refs.car.initFun(obj);
        });
      },
      /**
       * @name: 更改状态
       * @param {*} val
       * @return {*}
       * @desc:
       */
      changeStatus(val) {
        let params = {
          id: val.id,
          status: val.status,
        };
        fetch.status(params).then((res) => {
          if (res.code == 200) {
            this.getList();
          } else {
            this.getList();
            this.$message.error(res.message);
          }
        });
      },
      // 更新弹层状态
      onUpdateDrawer(status) {
        console.log("status", status);
        if (status == 1) {
          // 成功
          this.showDrawer = false;
          this.showDrawer2 = false;
          this.getList();
        } else if (status == -1) {
          // 失败
          this.showDrawer = false;
          this.showDrawer2 = false;
        }
      },
      /**
       * @name: 关闭弹层
       * @return {*}
       * @desc:
       */
      closeDrawerFun() {
        this.showDrawer = false;
        this.showDrawer2 = false;
        if (this.$refs.commonAdd) {
          this.$refs.commonAdd.resetForm();
        }
      },
      /**
       * @name: 点击子项 0新增 1编辑
       * @param {*} type
       * @param {*} id
       * @return {*}
       * @desc:
       */
      clickItem(type, row) {
        let that = this;
        this.showDrawer = true;
        this.isEdit = type;
        // 给组件传值
        let obj = {
          type: type,
          id: row ? row.id : "",
        };
        this.$nextTick(function () {
          that.$refs.commonAdd.initFun(obj);
        });
      },
      /* 查询按钮，页码重置，查询数据 */
      searchClick() {
        this.queryParam.page = 1;
        this.getList();
      },
      /* 查询tableData数据 */
      getList() {
        let that = this;
        this.listLoading = true;
        if (that.publish_time !== '' && that.publish_time !== null && that.publish_time !== undefined) {
          that.queryParam.begin_at = that.publish_time[0]
          that.queryParam.end_at = that.publish_time[1]
        } else {
          that.queryParam.begin_at = ''
          that.queryParam.end_at = ''
        }
        fetch.bindCount(that.queryParam).then((res) => {
          that.listLoading = false;
          that.tableData = res.result;
          // that.total = res.result.total;

        });
      },
      remove(row) {
        let that = this;
        that.$confirm("确定删除该内容吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            // 调用接口
            fetch.remove({ id: row.id }).then((res) => {
              if (res.code == 200) {
                that.$message.success(res.message);
                that.getList();
              } else {
                that.$message.error(res.message);
              }
            });
          })
          .catch(() => {});
      },
    },
  };
</script>

<style lang="scss" scoped>
    .app-container {
        min-height: calc(100vh - 98px);
    }
</style>
